const orangePalette = {
  main: '#FFD390',
  light: '#FFF1D7',
  dark: '#E6A14C'
};

export default orangePalette;